import React from "react";
import {VisitSearchDateComponent} from "../visit-application/visit-date";

export function Search1({
    searchHandler,
    searchInfo,
    setSearchInfo,
    siteInfoOptions = [],
    showSiteInfoOptions = false
}) {
    const selectedSiteInfo = siteInfoOptions.find((row) => String(row.seq) === String(searchInfo.siteInfoSeq));

    function submit(e) {
        e.preventDefault();
        searchHandler();
    }

    function getSiteInfoLabel() {
        return selectedSiteInfo ? selectedSiteInfo.name : "전체";
    }

    return (
        <form onSubmit={submit}>
            <div className="nv_contents_search nv_contents_search_type2">
                <p className="m_tit nv_bold pc_skip tpc_skip">기간 설정</p>
                <div className="nv_date_box">
                    <span className="icon_date">날짜 선택</span>
                    <VisitSearchDateComponent
                        minDate={null}
                        selectedHandler={(date) => setSearchInfo({...searchInfo, searchFromDate: date})}
                    />
                    <span>~</span>
                    <VisitSearchDateComponent
                        minDate={searchInfo.searchFromDate}
                        selectedHandler={(date) => setSearchInfo({...searchInfo, searchToDate: date})}
                    />
                </div>

                <p className="m_tit nv_bold pc_skip tpc_skip">검색조건 설정</p>
                <div className="nv_select_box">
                    <p id="conditionKey">
                        {searchInfo.visitorInfoSearchType === "all" && "전체"}
                        {searchInfo.visitorInfoSearchType === "visitorName" && "방문자명"}
                        {searchInfo.visitorInfoSearchType === "visitorCompany" && "방문자회사명"}
                        {searchInfo.visitorInfoSearchType === "visitorPhone" && "방문자연락처"}
                        {searchInfo.visitorInfoSearchType === "visitorCar" && "방문자차량번호"}
                        {searchInfo.visitorInfoSearchType === "card" && "방문증번호"}
                        {searchInfo.visitorInfoSearchType === "hostName" && "담당자명"}
                    </p>
                    <ul>
                        <li onClick={() => setSearchInfo({...searchInfo, visitorInfoSearchType: "all"})}>전체</li>
                        <li onClick={() => setSearchInfo({...searchInfo, visitorInfoSearchType: "visitorName"})}>방문자명</li>
                        <li onClick={() => setSearchInfo({...searchInfo, visitorInfoSearchType: "visitorCompany"})}>방문자회사명</li>
                        <li onClick={() => setSearchInfo({...searchInfo, visitorInfoSearchType: "visitorPhone"})}>방문자연락처</li>
                        <li onClick={() => setSearchInfo({...searchInfo, visitorInfoSearchType: "visitorCar"})}>방문자차량번호</li>
                        <li onClick={() => setSearchInfo({...searchInfo, visitorInfoSearchType: "card"})}>방문증번호</li>
                        <li onClick={() => setSearchInfo({...searchInfo, visitorInfoSearchType: "hostName"})}>담당자명</li>
                    </ul>
                </div>

                {showSiteInfoOptions && siteInfoOptions.length > 0 && (
                    <div className="nv_select_box">
                        <p id="siteInfoKey">{getSiteInfoLabel()}</p>
                        <ul>
                            <li onClick={() => setSearchInfo({...searchInfo, siteInfoSeq: ""})}>전체</li>
                            {siteInfoOptions.map((row) => (
                                <li key={row.seq} onClick={() => setSearchInfo({...searchInfo, siteInfoSeq: row.seq})}>
                                    {row.name}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                <div className="nv_search_box">
                    <input
                        type="text"
                        className="nv_input"
                        id="conditionValue"
                        title="검색"
                        value={searchInfo.searchValue}
                        onChange={(e) => setSearchInfo({...searchInfo, searchValue: e.target.value})}
                    />
                    <input type="submit" className="nv_search_icon tpc_skip m_skip" title="검색"/>
                </div>
                <div className="nv_search_box pc_skip tpc_skip" style={{width: "32px"}}>
                    <input type="submit" className="nv_search_icon" title="검색"/>
                </div>
            </div>
        </form>
    );
}
